<template>
    <div class="absolute flex justify-center flex-col items-center w-full h-full top-0 bg-white bg-opacity-80" >
        <svg class="animate-spin h-20 w-20 text-primary-default" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-50" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-primary-default pt-2 text-sm" v-text="loadingText"></span>
    </div>
</template>
<style>

</style>
<script>
import { useStore } from 'vuex'
import {computed} from 'vue'

export default {
    name: "AjaxLoader",
    components:{

    },
    data() {

    },
    mounted() {

    },
    setup(props){

    },
    methods:{

    },
    props: {
        loadingText: String
    }
}
</script>
